import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { LoginService } from '@dap/shared-api';
import Monitor from '@dap/monitor/sdk/index';
import UtilCache from '@dap/shared-utils/cache';
import Util from '@dap/shared-utils';
import { clearPending } from '@dap/shared-utils/http';
// import { helperRoutes } from './routers';
// import { pathToRegexp, compile } from 'path-to-regexp';

const jumpRule = {
    // Advertise2: { name: 'Advertise2Home' },
    // 暂时注释
    // Table2: { name: Util.isMobile() ? 'Table2DataGlobalH5' : 'Table2DataGlobal' },
    Table2: { name: 'Table2DataGlobal' },
};

function getPermission () {
    return new Promise((resolve) => {
        if (UtilCache.getLocalItem('permissions')) {
            resolve(true);
            return;
        }
        if (UtilCache.getLocalItem('token')) {
            LoginService.getAuthInfo().then((res) => {
                UtilCache.setLocalItem('permissions', res.data.permissions);
            }).finally(() => resolve(true));
            return;
        }
        resolve(true);
    });
}
function beforeRouter (router) {
    // eslint-disable-next-line consistent-return
    router.beforeEach(async (to, from, next) => {
        if (jumpRule[to.name]) {
            return next(jumpRule[to.name]);
        }
        console.log('helper from.name', from.name);
        console.log('helper to.name', to.name);

        clearPending();

        Util.setPageTitle(to);
        // window.addEventListener('appMeta', async event => {
        //     console.log('meta from sub app:', event);
        //     const { metaInfo } = event.detail;
        //     if (!to.name && metaInfo) {
        //         await Util.loadDict(to, metaInfo);
        //         next();
        //     };
        // });
        const token = UtilCache.getLocalItem('token');
        if (!token && to.path !== '/login') {
            next({ name: 'Login', query: { from: from.name } });
        } else if (to.path.startsWith('/observatory') && !Util.canSeeObservatory()) {
            next({ name: 'Advertise2' });
        } else if (to.name === from.name) {
            // 同name不需要判断是否需要加载新的字典,直接跳转
            next();
        } else {
            NProgress.start();
            await getPermission();
            await Util.loadDict(to);
            console.log('beforeRouter to1111', to);
            // console.log('test', to)
            // TODO YO 这里是为了获取首页的全的字典，后面需要替换更好的方案
            // if (to.path !== '/login') await Util.loadInitDict(to);
            NProgress.done();
            console.log('beforeRouter to2222', to);
            // 跳转不同name的路由
            // Monitor.handleChangeRouter(from, to);
            next();
        }
    });

    /**
     * 加个导航守卫，特殊处理基座监控下meta丢失的路由
     */
    router.afterEach(async (to, from, next) => {
        // console.log('help after to', to)
        // console.log('help after from', from)
        Monitor.handleChangeRouter(from, to);
        // if (to.path === '/advertise-2') {
        //     next({ name: 'Advertise2' });
        // }
    //     // 在这里获取当前的 path
    //     const currentPath = to.path;
    //     const matchedMeta = findMatchedRoute(helperRoutes, currentPath);
    //     if (matchedMeta) {
    //         console.log('matchedMeta', matchedMeta)
    //         Util.setPageTitle(matchedMeta);
    //         await Util.loadDict(matchedMeta);
    //     }
    //     // TODO Yo 在除首页某个页面退出重进，会没有首页的初始化字典。如果需要，打开这行注释，待确认
    //     // if (to.path !== '/login' && !UtilCache.getCacheWithChain('adDict.home')) await Util.loadInitDict(to);
    });
}

/**
 * 路由表匹配嵌套路由
 * @param {*} routes
 * @param {*} currentPath
 * @returns
 */
// function findMatchedRoute(routes, currentPath) {
//     console.log('currentPath', currentPath)
//     console.log('routes', routes)
//     for (const route of routes) {
//         if (route.children && route.children.length > 0) {
//           // 如果当前路由有子路由，继续匹配子路由的 path
//           const metaRoute = route.children.find(item => {
//               // 拼接父路由和子路由的 path
//               const path = `${route.path}/${item.path}`;
//               const regexp = pathToRegexp(path);
//               const match = regexp.exec(currentPath);
//               // 如果找到匹配的路由配置，返回对应的 meta 信息
//               return !!match;
//           });
//           return metaRoute;
//         }
//       }
//       return null;
// }

// function findRouteChildren(routes, rootPath, currentPath) {
//     const matchedRoute = routes.find(route => {
//         return route.path === rootPath && route.children && route.children.length > 0;
//     });
//     if (matchedRoute) {
//         const nestedChildren = matchedRoute.children;
//         const childRoute = nestedChildren.find(child => {
//             const path = `${rootPath}/${child.path}`;
//             const regexp = pathToRegexp(path);
//             const match = regexp.exec(currentPath);
//             return !!match;
//         });

//         if (childRoute) {
//             // 如果找到匹配的子路由，则递归查找其子路由的子路由
//             return findRouteChildren(nestedChildren, `${rootPath}/${childRoute.path}`, currentPath);
//         } else {
//             // 找不到匹配的子路由，直接返回父路由
//             return matchedRoute;
//         }
//     }

//     return null; // 没有找到匹配的路由
// }

export default {
    beforeRouter,
};
